window.addEventListener("load", () => document.body.classList.add("is-loaded"));
